(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('TaxCode', TaxCode);

    TaxCode.$inject = ['$resource'];

    function TaxCode ($resource) {
        var resourceUrl =  'api/tax-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
